import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Button from '@material-ui/core/Button';
import colorPalette from '~/theme/colorPalette.js';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CircularProgress from '@material-ui/core/CircularProgress';
import NeutralButton from "../../atoms/NeutralButton";
import React from "react";

const FormButton = ({
  submitting,
  pristine,
  text_first,
  text_second = null,
  loading=null,
  minWidth=null,
  disabled=null,
  arrow_icon =true,
  style =null,
  hexColorCode = colorPalette.primary,
}) => {

  return (
      <>
        <NeutralButton
            minWidth={minWidth}
            maxWidth={minWidth || '300px'}
            hexColorCode={hexColorCode}
            text={text_first}
            subText={text_second}
            type="submit"
            disabled={submitting || pristine || disabled}
            variant="outlined"
            css={style || styledButton}
            className="submitButton"
            endAdornment={ arrow_icon && <ArrowRightIcon /> || '' }
        />
      </>
  );
}

export default FormButton;


// ----- Style Component -----
const styledButton = css`
  margin: 2rem auto;
  text-align: center;
  font-weight: bold;
`;
